import { IPromise } from 'angular';
import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';

export class SearchBoxComponent implements angular.IComponentOptions {
  public templateUrl: string = 'ui-ng-search-box/src/search_input_box/search_input_box.html';
  public controller: any = SearchBoxController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    searchTerm: '<',
    changeCallback: '&',
    placeholderText: '@',
    shouldAutoFocus: '<?',
    shouldAutoSearch: '<?'
  };
}

export interface ISearchBoxChangeCallback {
  (value: string): void;
}

interface ISearchBoxChangeObject {
  placeholderText: ng.IChangesObject;
  searchTerm: ng.IChangesObject;
}

interface IHIInput extends HTMLElement {
  validate: () => void;
}

export class SearchBoxController {
  private shouldAutoFocus: boolean = true;
  private shouldAutoSearch: boolean = false;
  private searchTerm: string;
  private placeholderText: string;
  private changeCallback: () => ISearchBoxChangeCallback;
  private _changeCallback: ISearchBoxChangeCallback;
  private hideValidation: boolean = true;

  constructor(private $element: ng.IAugmentedJQuery, private $timeout: ng.ITimeoutService) {}

  clearInput(): void {
    this.searchTerm = '';
    this.updateSearch();
  }

  setSearchTerm(evt: any) {
    this.searchTerm = evt.originalEvent.detail.value;
    if (this.shouldAutoSearch) {
      this.updateSearch();
    }
    if (!this.hideValidation) {
      this.hideValidation = true;
    }
  }

  updateSearch(): void {
    this.hideValidation = false;
    const searchInputEle = this.$element.find('.search-input')[0] as IHIInput;
    searchInputEle.validate();
    this._changeCallback(this.searchTerm);
  }

  $onInit(): void {
    this._changeCallback = _4.isFunction(this.changeCallback) ? this.changeCallback() : angular.noop;
    this.clearInput();
    this.placeholderText = this.placeholderText ? this.placeholderText : 'Enter search term';

    if (this.shouldAutoFocus) {
      const searchInputEle = this.$element.find('.search-input')[0];
      searchInputEle.setAttribute('auto-focus-input', '');
    }
  }

  isMobile(): boolean {
    return PlatformUtility.isMobile();
  }
}



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-search-box/src/search_input_box/search_input_box_controller.ts